import {Component, EventEmitter, Input, OnChanges, Output, signal, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {MatListModule} from '@angular/material/list';
import {NgxPermissionsModule, NgxPermissionsService} from 'ngx-permissions';

export type MenuItem = {
  label: string;
  icon?: string;
  route?: string;
  subItems?: MenuItem[];
  visible?: boolean;
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  standalone: true,
  imports: [CommonModule, MatListModule, RouterLinkActive, RouterLink, MatIconModule, NgxPermissionsModule]
})

export class NavbarComponent implements OnChanges {
  @Input() collapsed: any;
  @Input() currentProfile: string | undefined;
  @Output() toggleCollapseEvent = new EventEmitter<void>();

  items = signal<MenuItem[]>([
    // {label: 'TABLEAU DE BORD', icon: 'space_dashboard', route: 'tableau-bord'},
    // {label: 'HISTORIQUE', icon: 'timer', route: 'historique'},
    // {label: 'AJOUTER UNE PROCEDURE', icon: 'post_add', route: 'create-procedure'},
    {label: 'PROCEDURES D\'EXPLOITATION', icon: 'view_list', route: 'liste-procedures'},
    {label: 'PROCEDURES ARCHIVÉES', icon: 'archive', route: 'liste-procedures-archivees'},
    {label: 'DOCUMENTS', icon: 'perm_media', route: 'liste-documents'},
    //{label: 'JOINT JS', icon: '', route: 'jointjs'},
    { label: 'ADMINISTRATION', icon: 'settings',
      subItems : [
        { label: 'LISTE DES UTILISATEURS', route: 'administration/utilisateurs' },
        { label: 'GROUPES DE DIFFUSION', route: 'groupe-diffusion' },
        { label: 'ENTITÉS', route: 'administration/entites' },
      ]
    }
  ]);

  isParametrageExpanded = false;

  constructor(private permissionsService: NgxPermissionsService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentProfile']) {
      if (this.currentProfile) {
        this.permissionsService.loadPermissions([this.currentProfile]);
        this.updateMenuItemVisibility();
      }
    }
  }

  toggleParametrage() {
    this.isParametrageExpanded = !this.isParametrageExpanded;
    console.log("Parametrage Expanded:", this.isParametrageExpanded);
  }

  toggleCollapseSidenav() {
    this.toggleCollapseEvent.emit();
  }

  updateMenuItemVisibility() {
    switch (this.currentProfile) {
      case 'Direction Exploitation':
      case 'Chargé de mission':
      case 'Administrateur OPUS':
        this.items.update((menuItems) => {
          return menuItems.map(item => ({
            ...item,
            visible: true
          }));
        });
      break;

      case 'Agent terrain':
      case 'PCL':
      case 'Direction Service Client':
      case 'PCSI':
        this.items.update((menuItems) => menuItems.map(item => {
          if (item.label === 'ADMINISTRATION' || item.label === 'PROCEDURES ARCHIVÉES') {
            return { ...item, visible: false };
          }
          return { ...item, visible: true };
        }));
      break;
    }
  }

}
